export const h = {
  navMenu: ["首页","预注册奖励", "英雄", "游戏元素"],
  }


// WEBPACK FOOTER //
// ./src/i18n/lan/cn.js